import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';
import { usePricingModulesState } from '../../../context/contexts/PricingModuleContext';
import { LogicalRoute, LogicalRouteImportProps } from '../../../routings/helpers/LogicalRoute';
import { CloudAIAgentSecurityBlockPage } from '../screens/blockPage/CloudAIAgentSecurityBlockPage';
import CloudAIAgentSecurityPage from '../screens/CloudAIAgentSecurityPage';

export const CloudAIAgentSecurityRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();

    const displayBlockPage = isPageBlocked(LAYOUT_TABS.AI_AGENT_SECURITY_CLOUD.ID);

    return (
        <LogicalRoute
            {...props}
            blockPageComponent={CloudAIAgentSecurityBlockPage}
            component={CloudAIAgentSecurityPage}
            displayBlockPage={displayBlockPage}
        />
    );
};
